'use client';
import { Icon } from '@/components/ui/Icon';
import { Bell, BookOpen, CircleHelp, MessagesSquare } from 'lucide-react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

export const ConnectWithUs = () => {
  const pathname = usePathname();
  const isOnBlogPage = pathname === '/blog';

  return (
    <div className="py-20 max-md:py-16 w-full max-w-[1072px] mx-auto px-6">
      <h2 className="lg:text-[48px] md:text-[64px] md:leading-[74px] text-[48px] leading-[54px] font-semibold tracking-[-0.96px] lg:leading-[56px] mb-8 font-interDisplay">
        Connect with us
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Link
          href="/guide"
          className=" p-5 h-[184px] bg-[#E5F2FF] rounded-[24px] flex flex-col justify-between  gap-2 hover:scale-[1.01] transition-all text-[#007AFF]"
        >
          <div className="flex w-fit flex-row items-center gap-1.5 px-2.5 py-[9px] bg-background rounded-lg text-sm leading-[14px]">
            <Icon as={CircleHelp} size="sm" />
            <span className="font-medium">Guide</span>
          </div>
          <span className="font-semibold font-interDisplay">Learn Anara</span>
        </Link>

        {/* todo connect with us */}

        {isOnBlogPage ? (
          <Link
            href="https://x.com/anaralabs"
            target="_blank"
            rel="noopener noreferrer"
            className="p-5 h-[184px] bg-[#F7EEFC] rounded-[24px] flex flex-col justify-between gap-2 hover:scale-[1.01] transition-all text-[#AF52DE]"
          >
            <div className="flex w-fit flex-row items-center gap-1.5 px-2.5 py-[9px] bg-background rounded-lg text-sm leading-[14px]">
              <div className="w-4 h-4 flex items-center justify-center">
                <MessagesSquare />
              </div>
              <span className="font-medium">Stay updated</span>
            </div>
            <span className="font-semibold font-interDisplay">
              Follow us on X
            </span>
          </Link>
        ) : (
          <Link
            href="/blog"
            className="p-5 h-[184px] bg-[#F7EEFC] rounded-[24px] flex flex-col justify-between gap-2 hover:scale-[1.01] transition-all text-[#AF52DE]"
          >
            <div className="flex w-fit flex-row items-center gap-1.5 px-2.5 py-[9px] bg-background rounded-lg text-sm leading-[14px]">
              <Icon as={BookOpen} size="sm" />
              <span className="font-medium">Blog</span>
            </div>
            <span className="font-semibold font-interDisplay">
              Stories from the team
            </span>
          </Link>
        )}

        <Link
          href="/changelog"
          className="p-5 md:col-span-2 h-[184px] bg-[#FFEAEE] rounded-[24px] flex flex-col justify-between  gap-2 hover:scale-[1.01] transition-all text-[#FF2D55]"
        >
          <div className="flex w-fit flex-row items-center gap-1.5 px-2.5 py-[9px] bg-background rounded-lg text-sm leading-[14px]">
            <Icon as={Bell} size="sm" />
            <span className="font-medium">Changelog</span>
          </div>
          <span className="font-semibold font-interDisplay">
            The latest product features and improvements
          </span>
        </Link>
      </div>
    </div>
  );
};
